import { resolveI18n } from "../../../commons/services/Translation"

export const LabelWidthClass = (i18n) => {
  return resolveI18n({ i18n, ko: 200, en: 250, vi: 300 })
}

export const OptionInfoCreateGrid = (i18n) => {
  return resolveI18n({ i18n, ko: "3fr 2fr", en: "1fr 1fr", vi: "1fr 1fr" })
}